import Vue from 'vue'
import Vuex from 'vuex'

import user from './module/user'
import app from './module/app'
import userManage from './module/user-manage'
import roleManage from './module/role-manage'
import quartzManage from './module/quartz-manage'
import settingManage from './module/setting-manage'
import dictManage from './module/dict-manage'
import i18nManage from './module/i18n-manage'
import logManage from './module/log-manage'
import messageManage from './module/message-manage'
import notepadManage from './module/notepad-manage'
import messageDetailManage from './module/message-detail-manage'
import bettingRecordManage from './module/betting-record-manage'
import transactionRecordManage from './module/transaction-record-manage'
import feedbackManage from './module/feedback-manage'
import adPosGeneral from './module/ad-pos-general'
import adSettlement from './module/ad-settlement'
import memberBuyRecord from './module/member-buy-record'
import integral from './module/integral'
import adUnitGeneral from './module/ad-unit-general'
import oss from './module/oss'
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    //
  },
  mutations: {
    //
  },
  actions: {
    //
  },
  mapGetters: {
    user,
    oss,
    feedbackManage,
    adSettlement,
    adPosGeneral,
    memberBuyRecord,
    integral,
    adUnitGeneral
  },
  modules: {
    user,
    app,
    oss,
    userManage,
    roleManage,
    quartzManage,
    settingManage,
    dictManage,
    i18nManage,
    logManage,
    notepadManage,
    messageManage,
    messageDetailManage,
    bettingRecordManage,
    transactionRecordManage,
    feedbackManage,
    adPosGeneral,
    adSettlement,
    memberBuyRecord,
    integral,
    adUnitGeneral
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js